import React, { useState } from "react";
import logo from "../../assets/app_logo.png";
import { translate } from "../../utils/translations/translate";
import Input from "../UI/Input";
import Button from "../UI/Button";
import { Link } from "react-router-dom";
import { StyledAuthSection, StyledForm, StyledLogo, StyledLoginButton, StyledBacktoLogin,ForgotPassGlobalStyles } from "./styles";
import { SITE_LINKS_SCHEMA } from "../../router/navlinks";
import { useFormik } from "formik";
import { ForgotPasswordFormValidationSchema } from "./helpers/schema";
import { useAuth } from "./hooks/useAuth";
import { InfoModal } from "../UI/InfoModal";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SendIcon from '@mui/icons-material/Send';
const ForgotPasswordForm = () => {
  const {
    isLoading,
    isError: errorMessage,
    requestTemporaryPassword,
  } = useAuth();
  const [isTmpPasswordRequested, setIsTmpPasswordRequested] = useState(false);
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: (values) => {
      requestTemporaryPassword(values).then((res) => {
        if (res && typeof res === "object" && res.StatusCode === 200) {
          setIsTmpPasswordRequested(true);
        }
      });
    },
    validationSchema: ForgotPasswordFormValidationSchema,
  });
  const { email } = formik.values;
  return (
    <StyledAuthSection className="tma_auth_content">
      <StyledLogo src={logo} alt="tma_app_logo" className="tma_app_logo" />
      <StyledForm
        className="tma_auth_form tma_forgotpass_form"
        onSubmit={formik.handleSubmit}
      >
      <h1 className="tma_form_title">{translate("labels.forgotPassword")}</h1>
        <div className="tma_form_helper_text">
          <p>{translate("labels.forgotPassInstructions")}</p>
        </div>
        <div className="tma_form_control">
          <Input
            id="email"
            type="email"
            name="email"
            value={email}
            placeholderLabelText={translate("labels.email")}
            labelText={""}
            showInfoToolTip={false}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
        </div>
        <StyledBacktoLogin>
          
            <KeyboardBackspaceIcon />
            <Link to={SITE_LINKS_SCHEMA.LOGIN}>
              {translate("labels.backToLogin")}
            </Link>
          
        </StyledBacktoLogin>
        <div className="tma_form-feedback">
          {errorMessage && <p className="tma_error">{errorMessage}</p>}
        </div>
        <StyledLoginButton>
          <Button
            iconcomponent={SendIcon}
            text={translate("labels.sendResetInstructions")}
            type="submit"
            isLoading={isLoading}
          />
        </StyledLoginButton>
      </StyledForm>
      {isTmpPasswordRequested && (
        <InfoModal
          onClose={() => {
            setIsTmpPasswordRequested(true);
            formik.setFieldValue("email", "");
          }}
          title={translate("labels.forgotPasswordModalTitle")}
          titleStyles={{ fontWeight: "bold", color: "green" }}
          primaryMessage={translate(
            "labels.forgotPassConfirmationInfo"
          ).replace("$email", email)}
          showActionButton={false}
        />
      )}
     <ForgotPassGlobalStyles />
    </StyledAuthSection>
  );
};

export { ForgotPasswordForm };
